<form [formGroup]="form" (ngSubmit)="onSubmit()" class="bulk-update-form">
    <div>
        <div class="dialog-heading">
            <h2 class="section-title m-0">
                {{ 'advancedMeasure.groupActions.form.header.' + dialogConfig.data.option | translate }}
            </h2>
            <p-button
                icon="ms ms-close"
                severity="secondary"
                [text]="true"
                [rounded]="true"
                [ariaLabel]="'common.close_button' | translate"
                (onClick)="onCancel()" />
        </div>
        @if (dialogConfig.data.option === 'statusId') {
            <div class="form-field">
                <label class="form-field__label form-field__label--required" for="bulk-status">{{
                    'advancedMeasure.table.status' | translate
                }}</label>
                <p-select
                    inputId="bulk-status"
                    formControlName="status"
                    [options]="statusOptions"
                    [placeholder]="'advancedMeasure.form.placeholder.status' | translate"
                    appendTo="body">
                    <ng-template let-status pTemplate="selectedItem">
                        <span class="status-option" [ngClass]="getStatusClass(status.key)">
                            <span class="material-symbols-outlined icon-sm" aria-hidden="true">{{ status.icon }}</span>
                            {{ status.label }}
                        </span>
                    </ng-template>
                    <ng-template let-status pTemplate="item">
                        <span class="status-option" [ngClass]="getStatusClass(status.key)">
                            <span class="material-symbols-outlined icon-sm" aria-hidden="true">{{ status.icon }}</span>
                            {{ status.label }}
                        </span>
                    </ng-template>
                </p-select>
                @if (form.controls.status.invalid && form.controls.status.touched) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
            </div>
        }
        @if (dialogConfig.data.option === 'dataUncertainty') {
            <div class="form-field">
                <label class="form-field__label form-field__label--required" for="bulk-uncertainty">{{
                    'advancedMeasure.table.uncertainty' | translate
                }}</label>
                <p-select
                    inputId="bulk-uncertainty"
                    [options]="uncertainty"
                    placeholder="None (0%)"
                    formControlName="uncertainty"
                    appendTo="body"></p-select>
                @if (form.controls.uncertainty.invalid && form.controls.uncertainty.touched) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
            </div>
        }
        @if (dialogConfig.data.option === 'analyticalCategoryId') {
            <div class="form-field">
                <label class="form-field__label form-field__label--required" for="bulk-analytical-category">{{
                    'advancedMeasure.table.analytical' | translate
                }}</label>
                <p-select
                    inputId="bulk-analytical-category"
                    formControlName="analyticalCategory"
                    [options]="dialogConfig.data.analyticalCategories"
                    [placeholder]="'advancedMeasure.form.placeholder.analytical' | translate"
                    optionLabel="name"
                    optionValue="id"
                    [filter]="true"
                    [filterPlaceholder]="'common.search' | translate"
                    appendTo="body"></p-select>
                @if (form.controls.analyticalCategory.invalid && form.controls.analyticalCategory.touched) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
            </div>
        }
        @if (dialogConfig.data.option === 'tagIds') {
            <div class="form-field">
                <label class="form-field__label form-field__label--required" for="bulk-tags">{{
                    'advancedMeasure.form.tag' | translate
                }}</label>
                <p-treeSelect
                    inputId="bulk-tags"
                    [options]="dialogConfig.data.tagsTreeOptions"
                    formControlName="tagIds"
                    selectionMode="multiple"
                    [metaKeySelection]="false"
                    [placeholder]="'advancedMeasure.form.placeholder.tag' | translate"
                    display="chip"
                    appendTo="body">
                </p-treeSelect>
                @if (form.controls.tagIds.invalid && form.controls.tagIds.touched) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
            </div>
        }
        @if (dialogConfig.data.option === 'ghgCategoryId') {
            <div class="form-field">
                <label class="form-field__label form-field__label--required" for="bulk-ghg-category">{{
                    'advancedMeasure.form.ghg-pCat' | translate
                }}</label>
                <p-select
                    inputId="bulk-ghg-category"
                    [options]="dialogConfig.data.ghgCategories"
                    formControlName="ghgCategory"
                    [placeholder]="'advancedMeasure.form.placeholder.ghg-pCat' | translate"
                    optionLabel="name"
                    optionValue="id"
                    [filter]="true"
                    [filterPlaceholder]="'common.search' | translate">
                </p-select>
                @if (form.controls.ghgCategory.invalid && form.controls.ghgCategory.touched) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
            </div>
        }
    </div>
    <div class="form-actions">
        <p-button severity="secondary" [label]="'common.cancel_button' | translate" (onClick)="onCancel()" />
        <p-button type="submit" [label]="'common.confirm_button' | translate" />
    </div>
</form>
